import type { LCVTilInterest } from '@/types/lcv/model';

export const parseLCVTilInterest = (value): LCVTilInterest => {
  return {
    uid: value.uid,
    down_payment_min: value.down_payment_min,
    down_payment_max: value.down_payment_max,
    m48: value.m48,
    m60: value.m60,
    m72: value.m72,
    m84: value.m84,
    // m96: value.m96,
  };
};
